module.exports = __webpack_public_path__ + "static/media/6b_website_logo_Platinum_clp.f32af76e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/6b_website_logo_Platinum_clp.jpg
// module id = 97
// module chunks = 0